// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"8dd98fe1","513":"c21f0c0d","703":"a21a8d0d","787":"ef6b32b5"}[chunkId] + ".chunk.js";
};